import { logError } from 'saddlebag-logger';

import { sendSlipstreamView, getInitialOptions } from './sharedFuncs';

class ViewSender {
  // Previous iteration used `this` and so ViewSender was a class. Keeping it as a class for now to avoid breaking changes, but this could be refactored to a simple function in the future.
  // eslint-disable-next-line class-methods-use-this
  sendView(viewOptions, getUtidFn, authState, useAbsoluteUrl = false) {
    let utid = null;
    let options = null;
    try {
      utid = getUtidFn();
      options = getInitialOptions(viewOptions.opts, viewOptions.trackingOpts);

      sendSlipstreamView(utid, options, authState, useAbsoluteUrl);
    } catch (error) {
      logError(error, {
        component: 'view-tracking',
        message: `${error}`,
        utid,
      });
    }
  }
}

export default ViewSender;
